import React from 'react';
import { Header } from 'semantic-ui-react';

import CreateAccountForm from './CreateAccountForm';

const CreateAccount = (props) => {
  return (
    <React.Fragment>
      <Header as="h2">
        New Account
      </Header>
      <CreateAccountForm />
    </React.Fragment>
  );
};

export default CreateAccount;
